// extracted by mini-css-extract-plugin
export default {"select":"AssigneeSearch_select__XRZ5l"};